import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _eea0ce0a = () => interopDefault(import('../pages/asbis-in-your-country.vue' /* webpackChunkName: "pages/asbis-in-your-country" */))
const _4f109c48 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _66d8eef8 = () => interopDefault(import('../pages/vendors/index.vue' /* webpackChunkName: "pages/vendors/index" */))
const _7a74181e = () => interopDefault(import('../pages/catalog/_slug.vue' /* webpackChunkName: "pages/catalog/_slug" */))
const _9b479f80 = () => interopDefault(import('../pages/documents/_slug/index.vue' /* webpackChunkName: "pages/documents/_slug/index" */))
const _44002698 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _e8d2fe4c = () => interopDefault(import('../pages/solution/_slug.vue' /* webpackChunkName: "pages/solution/_slug" */))
const _65224db0 = () => interopDefault(import('../pages/vendors/_slug.vue' /* webpackChunkName: "pages/vendors/_slug" */))
const _68a64efb = () => interopDefault(import('../pages/where-to-buy/_slug.vue' /* webpackChunkName: "pages/where-to-buy/_slug" */))
const _527dded8 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/asbis-in-your-country",
    component: _eea0ce0a,
    name: "asbis-in-your-country___en"
  }, {
    path: "/et",
    component: _4f109c48,
    name: "index___et"
  }, {
    path: "/vendors",
    component: _66d8eef8,
    name: "vendors___en"
  }, {
    path: "/et/asbis-in-your-country",
    component: _eea0ce0a,
    name: "asbis-in-your-country___et"
  }, {
    path: "/et/vendors",
    component: _66d8eef8,
    name: "vendors___et"
  }, {
    path: "/",
    component: _4f109c48,
    name: "index___en"
  }, {
    path: "/et/catalog/:slug?",
    component: _7a74181e,
    name: "catalog-slug___et"
  }, {
    path: "/et/documents/:slug",
    component: _9b479f80,
    name: "documents-slug___et"
  }, {
    path: "/et/news/:slug?",
    component: _44002698,
    name: "news-slug___et"
  }, {
    path: "/et/solution/:slug?",
    component: _e8d2fe4c,
    name: "solution-slug___et"
  }, {
    path: "/et/vendors/:slug",
    component: _65224db0,
    name: "vendors-slug___et"
  }, {
    path: "/et/where-to-buy/:slug?",
    component: _68a64efb,
    name: "where-to-buy-slug___et"
  }, {
    path: "/catalog/:slug?",
    component: _7a74181e,
    name: "catalog-slug___en"
  }, {
    path: "/documents/:slug",
    component: _9b479f80,
    name: "documents-slug___en"
  }, {
    path: "/et/:slug",
    component: _527dded8,
    name: "slug___et"
  }, {
    path: "/news/:slug?",
    component: _44002698,
    name: "news-slug___en"
  }, {
    path: "/solution/:slug?",
    component: _e8d2fe4c,
    name: "solution-slug___en"
  }, {
    path: "/vendors/:slug",
    component: _65224db0,
    name: "vendors-slug___en"
  }, {
    path: "/where-to-buy/:slug?",
    component: _68a64efb,
    name: "where-to-buy-slug___en"
  }, {
    path: "/:slug",
    component: _527dded8,
    name: "slug___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
